import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useGlobalLoaderContext } from '@module/mdrt-org/shared/components/providers/global-loader-context';
import { useUserContext } from '@module/mdrt-org/shared/components/providers/user-context';
import { OrgSharedDataTag } from '@module/mdrt-org/shared/utils/data/constants/tags';
import { getCompanyListing } from './get-company-listing';
import { type CompanyListingParams } from './types';
export const useCompanyListingQuery = params => {
  const $ = _c(18);
  const {
    accessToken
  } = useUserContext();
  const {
    setIsNonBlockingLoaderVisible
  } = useGlobalLoaderContext();
  const t0 = accessToken !== undefined;
  let t1;
  if ($[0] !== accessToken || $[1] !== params) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return getCompanyListing(accessToken, params, signal);
    };
    $[0] = accessToken;
    $[1] = params;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== params) {
    t2 = [OrgSharedDataTag.GET_COMPANY_LISTING, params];
    $[3] = params;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
    t3 = {
      enabled: t0,
      placeholderData: keepPreviousData,
      queryFn: t1,
      queryKey: t2,
      retry: false
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    data,
    isError,
    isFetching,
    isLoading
  } = useQuery(t3);
  let t4;
  let t5;
  if ($[9] !== isFetching || $[10] !== setIsNonBlockingLoaderVisible) {
    t4 = () => {
      setIsNonBlockingLoaderVisible(isFetching);
    };
    t5 = [isFetching, setIsNonBlockingLoaderVisible];
    $[9] = isFetching;
    $[10] = setIsNonBlockingLoaderVisible;
    $[11] = t4;
    $[12] = t5;
  } else {
    t4 = $[11];
    t5 = $[12];
  }
  useEffect(t4, t5);
  let t6;
  if ($[13] !== data || $[14] !== isError || $[15] !== isFetching || $[16] !== isLoading) {
    t6 = {
      data,
      isError,
      isFetching,
      isLoading
    };
    $[13] = data;
    $[14] = isError;
    $[15] = isFetching;
    $[16] = isLoading;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};